import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function DefesaExecucoes() {
  return (
    <section className="area-page">
      <h1>Defesa em Execuções Judiciais e Extrajudiciais</h1>

      <p>Imprevistos acontecem, e no campo eles acontecem com frequência!</p>

      <p>
        São muitas as adversidades que podem afetar um negócio a céu aberto:
        seca, chuva excessiva, geada, pragas... Isso sem falar que mesmo quando
        dá tudo certo com a produção ainda existem os riscos de mercado como
        aumento do valor dos insumos, queda do preço de venda, questões
        cambiárias, taxação, etc.
      </p>

      <p>
        Muitas vezes esse tipo de situação deixa o produtor rural em uma
        situação difícil, que o impede de honrar com todos os seus compromissos
        financeiros.
      </p>

      <p>
        O que muitos não sabem é que a Constituição Federal previu essa
        possibilidade e instituiu um microssistema de direitos e garantias para
        evitar que os produtores rurais tivessem que assumir esse risco
        sozinhos, afinal, toda a cadeia de produção (bancos, cooperativas, lojas
        de insumos, financiadores e fornecedores do agro em geral) "apostou" no
        sucesso do empreendimento e, se algo der errado por questões climáticas
        ou mercadológicas, não é justo que todos possam "se reservar ao direito"
        de receberem o que investiram, e que só o produtor rural tenha que
        assumir o prejuízo sozinho.
      </p>

      <p>
        O grande problema é que, por desconhecer esses direitos, a grande
        maioria dos produtores rurais ainda tenta se defender da maneira errada
        nos processos de execução, e por isso acaba perdendo seu patrimônio em
        penhoras e leilões, mesmo tendo direito às garantias estabelecidas pela
        Constituição.
      </p>

      <p>
        Se você quer ajuda para se defender da forma correta, ou mais
        informações sobre esse assunto, clique no botão abaixo para falar
        gratuitamente com nossos especialistas, direto no seu WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default DefesaExecucoes;
